import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VAutocomplete,{attrs:{"items":_vm.getExpensesCategories,"item-text":"name","item-value":"id","dense":"","label":"Select Expense Category"},on:{"change":function($event){return _vm.emitExpenseCategoryID()}},model:{value:(_vm.expenseCategoryID),callback:function ($$v) {_vm.expenseCategoryID=$$v},expression:"expenseCategoryID"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }